




























































































































import { SharedState } from "@/common/state";
import AppToggleBtn from "@/components/AppToggleBtn.vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { UseModal } from "@/components/root/modal";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import NotificationEmailModalVue from "../notification-email/NotificationEmailModal.vue";
import { RiskyUsersPolicyL0StatusItem } from "./data/model";
import { state } from "./data/state";
import RiskyUsersModalVue from "./top-risky-users-modal/RiskyUsersModal.vue";
export default Vue.extend({
  props: ["has_feature"],
  components: { AppToggleBtn, DropDownSimple, SkeletonLoaderItem },
  setup() {
    const policy_options: Array<{ id: number; name: string }> = [
      2,
      5,
      10,
      20,
    ].map((id) => ({ id, name: `Top ${id}%` }));

    const { status_list, is_loading, toggle_item_activity_state } = state;
    onMounted(async () => {
      SharedState.onReady(async () => {
        await state.init();
      });
    });

    const show_risky_users = async (item: RiskyUsersPolicyL0StatusItem) => {
      await UseModal().show(RiskyUsersModalVue, {
        id: item.id,
        name: item.name,
      });
    };

    const show_email_template = async (item: RiskyUsersPolicyL0StatusItem) => {
      await UseModal().show(NotificationEmailModalVue, {
        title: item.name,
        feature_id: "educate_risky_users",
        info_type: item.id,
      });
    };

    /*  const show_email_template = async (item: RiskyUsersPolicyL0StatusItem) => {
      await UseModal().show(NotificationTemplateModalVue, {
        name: item.name,
      });
    }; */

    const change_detected_level = async (
      item: RiskyUsersPolicyL0StatusItem,
      level: number
    ) => {
      await state.update_policy_level(item.id, level);
    };

    return {
      status_list,
      toggle_item_activity_state,
      show_risky_users,
      show_email_template,
      is_loading,
      policy_options,
      change_detected_level,
    };
  },
});
